// src/api.js
const API_BASE = (process.env.REACT_APP_API_BASE || "").trim() || "";

// If REACT_APP_API_BASE is set (Railway), it will use that.
// If not set (local dev with proxy), it uses "" and calls /api/* relative.
export const apiUrl = (path) =>
  `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;

// Tenant header helper (frontend)
export const getTenantHeaders = () => {
  const tenantId =
    localStorage.getItem("tenant_id") ||
    localStorage.getItem("tenantId") ||
    window.__TENANT_ID__ ||
    "";

  const token = localStorage.getItem("auth_token");

  const headers = { "x-tenant-id": String(tenantId) };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const withTenantHeaders = (headers = {}) => ({
  ...headers,
  ...getTenantHeaders(),
});

async function readJsonOrThrow(res, method, path) {
  const text = await res.text();
  if (!res.ok) throw new Error(`${method} ${path} failed (${res.status}): ${text.slice(0, 200)}`);

  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`${method} ${path} returned non-JSON: ${text.slice(0, 120)}`);
  }
}

export async function apiGet(path) {
  const res = await fetch(apiUrl(path), {
    method: "GET",
    headers: withTenantHeaders({ Accept: "application/json" }),
  });

  return readJsonOrThrow(res, "GET", path);
}

export async function apiPost(path, body) {
  const res = await fetch(apiUrl(path), {
    method: "POST",
    headers: withTenantHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(body ?? {}),
  });

  return readJsonOrThrow(res, "POST", path);
}

export async function apiPut(path, body) {
  const res = await fetch(apiUrl(path), {
    method: "PUT",
    headers: withTenantHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(body ?? {}),
  });

  return readJsonOrThrow(res, "PUT", path);
}

export async function apiPatch(path, body) {
  const res = await fetch(apiUrl(path), {
    method: "PATCH",
    headers: withTenantHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(body ?? {}),
  });

  return readJsonOrThrow(res, "PATCH", path);
}

export async function apiDelete(path) {
  const res = await fetch(apiUrl(path), {
    method: "DELETE",
    headers: withTenantHeaders({ Accept: "application/json" }),
  });

  return readJsonOrThrow(res, "DELETE", path);
}
